import ChangelogLabel from 'components/Layout/Changelog/ChangelogLabel';

interface Props {
  children: React.ReactNode;
  releaseDate?: string;
  version?: string;
}

const ChangelogWrapper = (props: Props) => {
  const { children, releaseDate, version } = props;

  return (
    <section className="changelog-wrapper">
      <ChangelogLabel timestamp={releaseDate} version={version} />
      {children}
    </section>
  );
};

export default ChangelogWrapper;
